<template>
  <v-card class="rsu">
    <div class="px-4 py-2">
      <v-layout justify-center row wrap>
        <v-flex xs12>
          <div class="text-right">
            <v-btn class="ma-0" @click="$emit('closemodal')" icon><v-icon>close</v-icon></v-btn>
          </div>
        </v-flex>
        <v-flex xs12>
          <div class="headline primary--text mb-1">
            <Typography h2 bold :label="`${edittype == 'edit' ? 'แก้ไข' : 'เพิ่ม'}ข้อมูลโครงการ`" />
          </div>
        </v-flex>
        <v-flex xs12>
          <div class="mt-1 mb-1 text-right">
            <toggle-button
              v-model="input.publish_status"
              :width="80"
              :height="25"
              :sync="true"
              :color="{ checked: '#52C41A', unchecked: '#BDBDBD', disabled: '#CCCCCC' }"
              :labels="{ checked: 'PUBLISH', unchecked: 'DRAFT' }"
              style="display: inline-block; font-size: 12px;text-align: left;"
            />
          </div>
        </v-flex>
        <v-flex xs12>
          <div
            style="width: 100%"
            class="form-control"
            :class="{ 'has-error': errors.has('ไฟล์ภาพ') }"
          >
            <uploadfile
              v-validate="'required'"
              name="ไฟล์ภาพ"
              v-model="input.projectimg"
            ></uploadfile>
            <span class="text-error" v-if="errors.has('ไฟล์ภาพ')">{{
              errors.first('ไฟล์ภาพ')
            }}</span>
          </div>
        </v-flex>
        <v-flex xs12 class="mb-3 mt-4">
          <div>
            <div class="pr-3" style="white-space: nowrap">
              <Typography h5 semiBold color="darkGrey" :label="'ชื่อโครงการ*'" />
            </div>
            <div
              style="width: 100%"
              class="form-control"
              :class="{ 'has-error': errors.has('ชื่อโครงการ') }"
            >
              <input
                v-validate="'required'"
                name="ชื่อโครงการ"
                placeholder="กรอกชื่อโครงการ"
                v-model="input.projectname"
                type="text"
                class="depainput rsu mb-0"
              />
              <span class="text-error" v-if="errors.has('ชื่อโครงการ')">{{
                errors.first('ชื่อโครงการ')
              }}</span>
            </div>
          </div>
        </v-flex>
        <v-flex xs12 class="mb-3">
          <div>
            <Typography h5 semiBold color="darkGrey" :label="'รายละเอียด*'" />
            <div
              style="width: 100%"
              class="form-control"
              :class="{ 'has-error': errors.has('รายละเอียด') }"
            >
              <textarea
                rows="4"
                placeholder="กรอกรายละเอียด"
                v-validate="'required'"
                name="รายละเอียด"
                v-model="input.projectdesc"
                type="text"
                style="height: auto !important;padding: 12px !important;margin: 0;resize: none;"
              />
              <span class="text-error" v-if="errors.has('รายละเอียด')">{{
                errors.first('รายละเอียด')
              }}</span>
            </div>
          </div>
        </v-flex>
        <v-flex xs12 class="mb-4">
          <div>
            <Typography h5 semiBold color="darkGrey" :label="'ลิงก์ดูรายละเอียด'" />
            <div
              style="width: 100%"
              class="form-control"
              :class="{ 'has-error': errors.has('ลิงก์ดูรายละเอียด') }"
            >
              <input
                placeholder="ลิงก์ดูรายละเอียด"
                v-validate="'isUrl'"
                name="ลิงก์ดูรายละเอียด"
                v-model="input.detaillink"
                type="text"
                class="depainput rsu mb-0"
              />
              <span class="text-error" v-if="errors.has('ลิงก์ดูรายละเอียด')">{{
                errors.first('ลิงก์ดูรายละเอียด')
              }}</span>
            </div>
          </div>
        </v-flex>
        <v-flex xs12 class="mb-2">
          <v-layout row wrap class="ma-0">
            <Typography
              h5
              semiBold
              color="darkGrey"
              :label="'ระยะเวลาที่สมัครได้* (ผู้สมัครมีสถานะเป็น waiting list)'"
            />
            <v-flex xs6 class="form-control pr-4">
              <div
                style="width: 100%"
                class="form-control"
                :class="{ 'has-error': errors.has('Start Date') }"
              >
                <date-picker
                  :append-to-body="false"
                  :clearable="false"
                  :editable="false"
                  name="Start Date"
                  v-model="input.projecteffdate"
                  v-validate="'required'"
                  valueType="date"
                  format="DD/MM/YYYY"
                  placeholder="เลือกวันที่เริ่ม"
                  confirm
                >
                  <template v-slot:footer="{ emit }">
                    <div style="text-align: left">
                      <button class="mx-btn mx-btn-text" @click="emit(new Date())">
                        Today
                      </button>
                    </div>
                  </template>
                </date-picker>
                <!-- <DatePickerWithoutButton
                  v-model="input.projecteffdate"
                  v-validate="'required'"
                  name="Start Date"
                  locale="th"
                >
                  <input
                    :value="convertDate(input.projecteffdate, 'projecteffdate')"
                    readonly
                    type="text"
                    class="depainput rsu dateinput"
                  />
                </DatePickerWithoutButton> -->
                <span class="text-error" v-if="errors.has('Start Date')">{{
                  errors.first('Start Date')
                }}</span>
              </div>
            </v-flex>
            <v-flex xs6 class="form-control">
              <div
                style="width: 100%"
                class="form-control"
                :class="{ 'has-error': errors.has('End Date') }"
              >
                <date-picker
                  :append-to-body="false"
                  :clearable="false"
                  :editable="false"
                  name="End Date"
                  v-model="input.projectenddate"
                  v-validate="'required'"
                  valueType="date"
                  format="DD/MM/YYYY"
                  placeholder="เลือกวันที่สิ้นสุด"
                  confirm
                >
                  <template v-slot:footer="{ emit }">
                    <div style="text-align: left">
                      <button class="mx-btn mx-btn-text" @click="emit(new Date())">
                        Today
                      </button>
                    </div>
                  </template>
                </date-picker>
                <!-- <DatePickerWithoutButton
                  v-model="input.projectenddate"
                  v-validate="'required'"
                  name="End Date"
                  locale="th"
                >
                  <input
                    :value="convertDate(input.projectenddate, 'projectenddate')"
                    readonly
                    type="text"
                    class="depainput rsu dateinput"
                  />
                </DatePickerWithoutButton> -->
                <span class="text-error" v-if="errors.has('End Date')">{{
                  errors.first('End Date')
                }}</span>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12>
          <v-layout row wrap class="ma-0">
            <Typography
              h5
              semiBold
              color="darkGrey"
              :label="'ระยะเวลาโครงการเปิด-ปิดโครงการ* (นอกเหนือจากระยะเวลานี้โครงการไม่แสดงผล)'"
            />
            <v-flex xs6 class="form-control pr-4 mb-2">
              <div
                style="width: 100%"
                class="form-control"
                :class="{ 'has-error': errors.has('Start Date show') }"
              >
                <date-picker
                  :append-to-body="false"
                  :clearable="false"
                  :editable="false"
                  name="Start Date show"
                  v-model="input.showstartdate"
                  v-validate="'required'"
                  valueType="date"
                  format="DD/MM/YYYY"
                  placeholder="เลือกวันที่เริ่ม"
                  confirm
                >
                  <template v-slot:footer="{ emit }">
                    <div style="text-align: left">
                      <button class="mx-btn mx-btn-text" @click="emit(new Date())">
                        Today
                      </button>
                    </div>
                  </template>
                </date-picker>
                <!-- <DatePickerWithoutButton
                  v-model="input.showstartdate"
                  v-validate="'required'"
                  name="Start Date show"
                  locale="th"
                >
                  <input
                    :value="convertDate(input.showstartdate, 'showstartdate')"
                    readonly
                    type="text"
                    class="depainput rsu dateinput"
                  />
                </DatePickerWithoutButton> -->
                <span class="text-error" v-if="errors.has('Start Date show')">{{
                  errors.first('Start Date show')
                }}</span>
              </div>
            </v-flex>
            <v-flex xs6 class="form-control mb-2">
              <div
                style="width: 100%"
                class="form-control"
                :class="{ 'has-error': errors.has('End Date show') }"
              >
                <date-picker
                  :append-to-body="false"
                  :clearable="false"
                  :editable="false"
                  name="End Date show"
                  v-model="input.showenddate"
                  v-validate="'required'"
                  valueType="date"
                  format="DD/MM/YYYY"
                  placeholder="เลือกวันที่สิ้นสุด"
                  confirm
                >
                  <template v-slot:footer="{ emit }">
                    <div style="text-align: left">
                      <button class="mx-btn mx-btn-text" @click="emit(new Date())">
                        Today
                      </button>
                    </div>
                  </template>
                </date-picker>
                <!-- <DatePickerWithoutButton
                  v-model="input.showenddate"
                  v-validate="'required'"
                  name="End Date show"
                  locale="th"
                >
                  <input
                    :value="convertDate(input.showenddate, 'showenddate')"
                    readonly
                    type="text"
                    class="depainput rsu dateinput"
                  />
                </DatePickerWithoutButton> -->
                <span class="text-error" v-if="errors.has('End Date show')">{{
                  errors.first('End Date show')
                }}</span>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 class="mb-4">
          <Typography h5 semiBold color="darkGrey" :label="'ประเภทโครงการ*'" />
          <div
            style="width: 100%"
            class="form-control"
            :class="{ 'has-error': errors.has('ประเภทโครงการ') }"
          >
            <multiselect
              v-validate="'required'"
              name="ประเภทโครงการ"
              placeholder="เลือกประเภทโครงการ"
              v-model="input.typeid"
              :show-labels="false"
              :searchable="true"
              :options="optionsType.map(val => val.id)"
              :custom-label="customLabel"
            >
              <span slot="caret" slot-scope="{ toggle }" class="arrow">
                <v-icon class="darkBlue" aria-hidden="false" size="24px">
                  mdi-chevron-down
                </v-icon>
              </span>
            </multiselect>
            <span class="text-error" v-if="errors.has('ประเภทโครงการ') && !input.typeid">{{
              errors.first('ประเภทโครงการ')
            }}</span>
          </div>
        </v-flex>
        <v-flex xs6>
          <Typography h5 semiBold color="darkGrey" :label="'โครงการสำหรับ'" />
          <v-layout row wrap>
            <v-flex class="mt-0" xs12>
              <v-checkbox
                class="mt-0"
                hide-details
                v-model="foruser"
                value="นิติบุคคล"
                label="นิติบุคคล"
              ></v-checkbox>
            </v-flex>
            <v-flex class="mt-0" xs12>
              <v-checkbox
                class="mt-0"
                hide-details
                v-model="foruser"
                value="บุคคลธรรมดา"
                label="บุคคลธรรมดา"
              ></v-checkbox>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs6>
          <Typography h5 semiBold color="darkGrey" :label="'สถานะ DP ที่สามารถสมัครได้'" />
          <v-layout row wrap>
            <v-flex class="mt-0" xs12>
              <v-checkbox
                class="mt-0"
                hide-details
                v-model="foruser"
                value="DP"
                label="DP"
              ></v-checkbox>
            </v-flex>
            <v-flex class="mt-0" xs12>
              <v-checkbox
                class="mt-0"
                hide-details
                v-model="foruser"
                value="รออนุมัติ DP"
                label="รออนุมัติ DP"
              ></v-checkbox>
            </v-flex>
            <v-flex class="mt-0" xs12>
              <v-checkbox
                class="mt-0"
                hide-details
                v-model="foruser"
                value="Non-DP"
                label="Non-DP"
              ></v-checkbox>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12>
          <v-layout row wrap>
            <v-flex class="mt-0" xs12>
              <v-checkbox
                class="mt-0 bold-lb"
                hide-details
                v-model="isautoapproved"
                value="อนุมัติสินค้าอัตโนมัติ"
                label="อนุมัติสินค้าอัตโนมัติ"
              ></v-checkbox>
            </v-flex>
            <v-flex class="mt-0" xs12>
              <v-checkbox
                class="mt-0 bold-lb"
                hide-details
                v-model="isautobadge"
                value="ติดตราสัญลักษณ์อัตโนมัติ"
                label="ติดตราสัญลักษณ์อัตโนมัติ"
              ></v-checkbox>
            </v-flex>
            <v-flex class="mt-0" xs6 v-if="isautobadge">
              <div style="width: 260px;margin-left: 30px" class="form-control">
                <DropdownMenu
                  v-model="autobadge"
                  :options="badgeOptions"
                  :nametype="true"
                  @idSelect="badgeSelect"
                  @changeInput="updateInput(autobadge, $event)"
                >
                  <input
                    placeholder="เลือกตราสัญลักษณ์"
                    type="text"
                    class="depainput rsu"
                    :value="autobadge"
                  />
                </DropdownMenu>
              </div>
            </v-flex>
            <v-flex class="mt-0" xs12>
              <v-checkbox
                class="mt-0 bold-lb"
                hide-details
                v-model="isautodp"
                value="เป็น DP อัตโนมัติ"
                label="เป็น DP อัตโนมัติ"
              ></v-checkbox>
            </v-flex>
            <v-flex class="mt-0" xs12>
              <v-checkbox
                class="mt-0 bold-lb"
                hide-details
                v-model="isconnecttechhunt"
                value="เชื่อมต่อกับ Techhunt"
                label="เชื่อมต่อกับ Techhunt"
              ></v-checkbox>
            </v-flex>
            <v-flex class="mt-0" xs12>
              <v-checkbox
                class="mt-0 bold-lb"
                hide-details
                v-model="isapplicantfee"
                value="มีค่าธรรมเนียมการสมัครเข้าร่วมโครงการ"
                label="มีค่าธรรมเนียมการสมัครเข้าร่วมโครงการ"
              ></v-checkbox>
            </v-flex>
            <v-flex class="mt-0" xs6 v-if="isapplicantfee">
              <div style="width: 260px;margin-left: 30px" class="form-control">
                <label class="unit-text" data-unit="บาท">
                  <input
                    name="applicantfee"
                    v-model.number="applicantfee"
                    type="number"
                    step="0.01"
                    min="0.00"
                    @input="validFee"
                    class="depainput rsu mb-0 "
                  />
                </label>
              </div>
            </v-flex>
            <v-flex class="mt-0" xs12>
              <v-checkbox
                class="mt-0 bold-lb"
                hide-details
                v-model="ismonthdurationexpire"
                value="มีระยะเวลาหมดอายุ"
                label="มีระยะเวลาหมดอายุ"
              ></v-checkbox>
            </v-flex>
            <v-flex class="mt-0" xs6 v-if="ismonthdurationexpire">
              <div style="width: 260px;margin-left: 30px" class="form-control">
                <DropdownMenu v-model="monthdurationexpire" :options="expOptions">
                  <input
                    placeholder="เลือกวันหมดอายุ"
                    type="text"
                    class="depainput rsu"
                    :value="monthdurationexpire"
                  />
                </DropdownMenu>
              </div>
            </v-flex>
            <v-flex class="mt-0" xs12>
              <v-checkbox
                class="mt-0 bold-lb"
                hide-details
                v-model="isregistertechhunt"
                value="สมัครผ่าน Techhunt"
                label="สมัครผ่าน Techhunt"
              ></v-checkbox>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 class="mb-4">
          <div>
            <Typography
              h5
              semiBold
              color="darkGrey"
              :label="'ข้อมูลติดต่อ (แสดงเมื่อกดปุ่ม \'ติดต่อ\')*'"
            />
            <div
              style="width: 100%"
              class="form-control"
              :class="{ 'has-error': errors.has('ข้อมูลติดต่อ') }"
            >
              <textarea
                rows="3"
                placeholder="เช่น ฝ่าย A: คุณสมชาย โทร 02-xxx-xxxx ต่อ 123"
                name="ข้อมูลติดต่อ"
                v-model="input.contactinfo"
                v-validate="'required'"
                type="text"
                style="height: auto !important;padding: 12px !important;margin: 0;resize: none;"
              />
              <span class="text-error" v-if="errors.has('ข้อมูลติดต่อ')">{{
                errors.first('ข้อมูลติดต่อ')
              }}</span>
            </div>
          </div>
        </v-flex>
        <v-flex xs12>
          <Typography h5 semiBold color="darkGrey" :label="'โครงการที่จำเป็นต้องเข้าร่วมมาก่อน'" />
          <div style="width: 100%" class="form-control">
            <multiselect
              name="โครงการที่จำเป็นต้องเข้าร่วมมาก่อน"
              class="multi-tag-large"
              :show-labels="false"
              :searchable="true"
              :options="this.projects"
              :multiple="true"
              :taggable="true"
              label="projectname"
              track-by="id"
              placeholder="เลือกโครงการ"
              v-model="preprojects"
            >
              <span slot="caret" slot-scope="{ toggle }" class="arrow d-none">
                <v-icon class="darkBlue" aria-hidden="false" size="24px">
                  mdi-chevron-down
                </v-icon>
              </span>
            </multiselect>
          </div>
        </v-flex>

        <v-flex v-if="input.typeid" :key="removed" xs12 class="mt-3">
          <div v-for="(item, k) in projectTypeData" :key="k" class="mb-2 typeCard">
            <div class="typeCardHeader">
              <!-- <span class="headerNumber">
                <Typography h4 bold :label="`${k + 1}`" />
              </span> -->
              <Typography class="headerText" h4 bold :label="`${item.name}`" />
            </div>
            <div class="pa-2 typeCardBody">
              <div class="typeCardStep" v-for="(step, stepindex) in item.steps" :key="step.id">
                <Typography h5 semiBold :label="`ขั้นตอนที่${stepindex + 1} : ${step.name}`" />
                <v-divider></v-divider>
                <div class="mt-3">
                  <Typography h5 semiBold :label="`การเปลี่ยนสถานะ DP`" color="darkGrey" />
                  <v-flex class="mt-2" xs12>
                    <div class="form-control">
                      <DropdownMenu
                        v-model="step.dpType"
                        :options="statusOption"
                        @changeInput="updateInput(step.dpType, $event)"
                      >
                        <input
                          placeholder="เลือกสถานะ"
                          type="text"
                          class="depainput rsu"
                          :value="step.dpType"
                        />
                      </DropdownMenu>
                    </div>
                  </v-flex>
                </div>
                <div v-if="stepindex === item.steps.length - 1" class="mt-2 mb-3">
                  <Typography h5 semiBold :label="`ติดแท็กลูกค้า`" color="darkGrey" />
                  <multiselect
                    :key="tagKey"
                    :options="tagOptions"
                    track-by="id"
                    label="tagcustomer"
                    v-model="step.tags"
                    :placeholder="$t('Tags')"
                    :multiple="true"
                    :taggable="true"
                    class="multi-tag-small"
                    @input="updateInput(step.notify, $event)"
                  >
                    <span slot="caret" slot-scope="{ toggle }" class="arrow d-none">
                      <v-icon class="darkBlue" aria-hidden="false" size="24px">
                        mdi-chevron-down
                      </v-icon>
                    </span>
                  </multiselect>
                </div>
                <!-- v-if="stepindex === 0 && k === 0" -->
                <!-- <div v-if="stepindex === 0 && k === 0">
                  <div class="multiselect__tags" style="background-color: #eee">
                    <div class="multiselect__tags-wrap" style="display: none"></div>
                    <div class="multiselect__spinner" style="display: none"></div>
                    <input
                      name="default testkpl7yxoa"
                      type="text"
                      autocomplete="off"
                      placeholder="เลือกสมาชิก"
                      tabindex="0"
                      class="multiselect__input"
                      style="width: 0px; position: absolute; padding: 0px"
                    />
                    <span style="font-size: 16px; color: grey" class="multiselect__placeholder">
                      ผู้สมัคร
                    </span>
                  </div>
                </div> -->
                <div
                  v-if="stepindex != 0"
                  class="mt-2 mb-3 form-control"
                  :class="{ 'has-error': errors.has(step.name + step.id) }"
                >
                  <Typography h5 semiBold :label="`เลือกแอดมิน*`" color="darkGrey" />
                  <multiselect
                    :options="useUserData"
                    :multiple="true"
                    :taggable="true"
                    :show-labels="false"
                    :searchable="true"
                    :name="step.name + step.id"
                    class="multi-tag-small"
                    label="useName"
                    track-by="memberid"
                    v-model="step.notify"
                    v-validate="'required'"
                    placeholder="เลือกแอดมิน"
                    @input="updateInput(step.notify, $event)"
                  >
                    <span slot="caret" slot-scope="{ toggle }" class="arrow d-none">
                      <v-icon class="darkBlue" aria-hidden="false" size="24px">
                        mdi-chevron-down
                      </v-icon>
                    </span>
                  </multiselect>
                  <span class="text-error" v-if="errors.has(step.name + step.id)">{{
                    errors.first(step.name + step.id)
                      ? `กรุณากรอก แอดมิน : ขั้นตอน${step.name}`
                      : 'กรุณาเลือก แอดมิน'
                  }}</span>
                </div>
                <!-- <div
                  v-else
                  style="width: 100%"
                  class="form-control"
                  :class="{ 'has-error': errors.has(step.name + step.id) }"
                >
                  <v-autocomplete
                    label="เลือกแอดมิน"
                    :data-vv-as="'สมาชิกใน ' + step.name"
                    v-validate="'required'"
                    :name="step.name + step.id"
                    multiple
                    :error-messages="
                      errors.first(step.name + step.id) ? [errors.first(step.name + step.id)] : []
                    "
                    v-model="step.notify"
                    :items="useUserData"
                    box
                    chips
                    :item-text="'useName'"
                    :item-value="'memberid'"
                    @change="onChangeSelect"
                  >
                    <template v-slot:selection="data">
                      <v-chip
                        :input-value="data.item.selected"
                        close
                        @input="remove(data.item, k, stepindex)"
                        style="background-color:#0e3154 !important;color:white;border-radius: 5px;    padding: 4px 10px;"
                      >
                        <v-list-tile-avatar>
                          <img v-if="data.item.profile_pic" :src="data.item.profile_pic" />
                          <img v-else :src="'/static/img/assets/livechat/profile.png'" />
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                          <v-list-tile-title>{{
                            data.item.name || data.item.institute_name
                          }}</v-list-tile-title>
                          <v-list-tile-sub-title v-html="data.item.app"></v-list-tile-sub-title>
                        </v-list-tile-content>
                      </v-chip>
                    </template>
                    <template v-slot:item="data">
                      <template v-if="typeof data !== 'object'">
                        <v-list-tile-content v-text="data.item"></v-list-tile-content>
                      </template>
                      <template v-else>
                        <v-list-tile-avatar>
                          <img v-if="data.item.profile_pic" :src="data.item.profile_pic" />
                          <img v-else src="/static/img/Portrait_Placeholder.png" />
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                          <v-list-tile-title>{{
                            data.item.name || data.item.institute_name
                          }}</v-list-tile-title>
                        </v-list-tile-content>
                      </template>
                    </template>
                  </v-autocomplete>
                </div> -->
              </div>
            </div>
          </div>
        </v-flex>
        <v-flex xs12 class="mb-1 mt-5 center">
          <v-btn
            class="rsu customCancelBtn"
            @click="$emit('closemodal')"
            round
            outline
            color="primary"
            >{{ $t('cancel') }}</v-btn
          >
          <v-btn
            class="rsu customConfirmBtn"
            :loading="saveloading"
            @click="saveData"
            round
            depressed
            color="primary"
            >{{ $t('Save') }}</v-btn
          >
        </v-flex>
      </v-layout>
    </div>
  </v-card>
</template>

<script>
import Multiselect from 'vue-multiselect'
import Typography from '@/components/elements/Typography.vue'
import api from '@/api'
import UploadFileButton from '@/components/elements/UploadFileButton.vue'
import AutoresizeTextarea from '@/components/elements/AutoresizeTextarea.vue'
import DropdownMenu from '@/components/elements/DropdownMenu.vue'
import DatePickerWithoutButton from '@/components/elements/DatePickerWithoutButton.vue'
import uploadfile from '@/components/elements/uploadfiletest.vue'
import moment from 'moment'
import { ToggleButton } from 'vue-js-toggle-button'
import { VueDatePicker } from '@mathieustan/vue-datepicker'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
// import 'vue2-datepicker/locale/th';
export default {
  props: ['value', 'edittype'],
  components: {
    Multiselect,
    Typography,
    UploadFileButton,
    AutoresizeTextarea,
    DatePickerWithoutButton,
    uploadfile,
    ToggleButton,
    VueDatePicker,
    DatePicker,
    DropdownMenu
  },
  data() {
    return {
      dateFormat: {
        stringify: date => {
          return date
            ? moment(date)
                .add(543, 'y')
                .format('DD/MM/YYYY')
            : null
        },
        parse: value => {
          return value
            ? moment(value, 'DD/MM/YYYY')
                .subtract(543, 'y')
                .toDate()
            : null
        }
      },
      statusOption: [
        'ไม่เปลี่ยนสถานะลูกค้า (default)',
        'เปลี่ยนสถานะเป็น Non-DP',
        'เปลี่ยนสถานะเป็น รออนุมัติ DP',
        'เปลี่ยนสถานะเป็น DP'
      ],
      tagKey: 0,
      tagOptions: [],
      badgeOptions: [],
      expOptions: ['1 เดือน', '3 เดือน', '6 เดือน', '1 ปี'],
      update_tags: [],
      removed: 0,
      typedata: {},
      data: '',
      temptypeid: '',
      searchText: [],
      input: {
        projectname: '',
        projectdesc: '',
        projectimg: '',
        projecteffdate: '',
        projectenddate: '',
        showstartdate: '',
        showenddate: '',
        typeid: '',
        projectdata: '',
        publish_status: false,
        depaprojectid: '',
        contactinfo: ''
      },
      foruser: [],
      isautoapproved: false,
      isautobadge: false,
      autobadge: null,
      autobadgeSelectId: null,
      isautodp: false,
      isconnecttechhunt: false,
      isapplicantfee: false,
      applicantfee: null,
      ismonthdurationexpire: false,
      monthdurationexpire: null,
      isregistertechhunt: false,
      preprojects: [],
      projects: [],
      optionsStatus: ['Inactive', 'Active'],
      optionsStep: ['พิจารณา'],
      pagination: {},
      desserts: [
        {
          process: 'process1',
          step: ['step1', 'step2', 'step3']
        }
      ],
      headers: [
        { text: 'Process', value: 'process', align: 'center' },
        { text: 'Step', value: 'step', align: 'center' }
      ],
      saveloading: false
    }
  },
  async mounted() {
    await this.getTagCustomer()
    this.getProject()
    await this.getBadges()
    if (this.edittype == 'edit') {
      // console.log(this.value)
      this.input = {
        ...this.value,
        projectdata: JSON.parse(this.value.projectdata),
        projecteffdate: moment(this.value.projecteffdate).toDate(),
        projectenddate: moment(this.value.projectenddate).toDate(),
        showstartdate: moment(this.value.showstartdate).toDate(),
        showenddate: moment(this.value.showenddate).toDate()
      }
      if (this.value.preprojects) {
        this.preprojects = this.value.preprojects
      }
      // console.log('this.value.autobadgeid', this.value.autobadgeid)
      // console.log('badgeOptions', this.badgeOptions)
      // console.log('this.value',this.value)
      // console.log('this.value',this.value.foruser)
      let matchAutobadge;
      if (this.value.autobadgeid) {
         matchAutobadge = this.badgeOptions.find(el => el.id == this.value.autobadgeid)
        // console.log('matchAutobadge', matchAutobadge)
      }

      this.isautoapproved = this.value.isautoapproved ? 'อนุมัติสินค้าอัตโนมัติ' : null
      this.autobadge = matchAutobadge ? matchAutobadge.name : null
      this.autobadgeSelectId = matchAutobadge ? matchAutobadge.id : null
      this.isautobadge = this.value.autobadgeid ? 'ติดตราสัญลักษณ์อัตโนมัติ' : null
      this.isautodp = this.value.isautodp ? 'เป็น DP อัตโนมัติ' : null
      this.isconnecttechhunt = this.value.isconnecttechhunt ? 'เชื่อมต่อกับ Techhunt' : null
      this.isapplicantfee = this.value.applicantfee ? 'มีค่าธรรมเนียมการสมัครเข้าร่วมโครงการ' : null
      this.applicantfee = Number(this.value.applicantfee)
      this.isregistertechhunt = this.value.isregistertechhunt ? 'สมัครผ่าน Techhunt' : null
      if (this.value.monthdurationexpire == 1) {
        this.ismonthdurationexpire = 'มีระยะเวลาหมดอายุ'
        this.monthdurationexpire = '1 เดือน'
      } else if (this.value.monthdurationexpire == 3) {
        this.ismonthdurationexpire = 'มีระยะเวลาหมดอายุ'
        this.monthdurationexpire = '3 เดือน'
      } else if (this.value.monthdurationexpire == 6) {
        this.ismonthdurationexpire = 'มีระยะเวลาหมดอายุ'
        this.monthdurationexpire = '6 เดือน'
      } else if (this.value.monthdurationexpire == 12) {
        this.ismonthdurationexpire = 'มีระยะเวลาหมดอายุ'
        this.monthdurationexpire = '1 ปี'
      }
      if (this.value.foruser) {
        this.foruser = this.value.foruser.split(',')
      }
      if (this.input.tags) {
        this.input.tags = this.input.tags.split(',')
      }
      this.temptypeid = this.input.typeid
    }

    this.clearValidate()
  },
  computed: {
    optionsType() {
      return [...this.$store.state.projecttype]
    },
    useUserData() {
      let userData = this.$store.state.usersdata
      for (let i = 0; i < userData.length; i++) {
        userData[i].useName = userData[i].name || userData[i].institute_name
      }
      return userData
    },
    projectTypeData() {
      if (this.input.typeid) {
        if (this.edittype == 'edit' /*  && this.input.typeid == this.temptypeid */) {
          var projecttype = this.$store.state.projecttype.find(el => el.id == this.input.typeid)
          if (projecttype) {
            this.typedata = [
              ...this.$store.state.projecttype.find(el => el.id == this.input.typeid).typedata
            ]
            this.typedata.forEach((el, key) => {
              this.typedata[key].steps.forEach((val, k) => {
                var currentStep = this.input.projectdata.find(
                  step => step.stepid == this.typedata[key].steps[k].id
                )
                let dpType = 'ไม่เปลี่ยนสถานะลูกค้า (default)'
                if (currentStep && currentStep.dpType && currentStep.dpType == 'DP') {
                  dpType = 'เปลี่ยนสถานะเป็น DP'
                } else if (currentStep && currentStep.dpType && currentStep.dpType == 'Non-DP') {
                  dpType = 'เปลี่ยนสถานะเป็น Non-DP'
                } else if (
                  currentStep &&
                  currentStep.dpType &&
                  currentStep.dpType == 'รออนุมัติ DP'
                ) {
                  dpType = 'เปลี่ยนสถานะเป็น รออนุมัติ DP'
                }
                if (
                  currentStep &&
                  Object.keys(currentStep).includes('notify') &&
                  !!currentStep.notify
                ) {
                  var matchNotify = currentStep.notify.map((el, idx) => {
                    let matchMember = this.useUserData.find(user => user.memberid == el)
                    return matchMember
                  })
                }
                Object.assign(this.typedata[key].steps[k], {
                  notify: currentStep && matchNotify,
                  tags:
                    currentStep && currentStep.tags
                      ? currentStep.tags.split(',').map(tag => {
                          const tagObj = this.tagOptions.find(ele => ele.tagcustomer == tag)
                          return tagObj
                        })
                      : [],
                  dpType
                })
              })
            })
          }
          // console.log('this.typedata last', this.typedata)
          return this.typedata
        } else {
          // console.log('slo', this.$store.state.projecttype, this.input.typeid)
          return [...this.$store.state.projecttype.find(el => el.id == this.input.typeid).typedata]
        }
      } else return {}
    }
  },
  methods: {
    clearValidate() {
      this.formValues = { ...this.input }
      this.$validator.pause()
      this.$nextTick(() => {
        this.$validator.errors.clear()
        this.$validator.fields.items.forEach(field => field.reset())
        this.$validator.fields.items.forEach(field => this.errors.remove(field))
        this.$validator.resume()
      })
    },
    async getTagCustomer() {
      try {
        let res = await api.getTagCustomerDropDown()
        // console.log(res.data)
        // return res.data
        this.tagOptions = res.data
      } catch (e) {
        // console.log(e)
      }
    },
    badgeSelect(id) {
      // console.log('idselect', id)
      this.autobadgeSelectId = id
    },
    validFee(event) {
      const rawValue = event.target.value
      const newValue = parseFloat(rawValue.replace(/[^\d.]/g, '')).toFixed(2)
      this.applicantfee = newValue
    },
    getProject() {
      return new Promise(resolve => {
        api.getdepaproject({}, (err, response) => {
          if (response.responsecode == 200) {
            this.projects = response.data
            resolve()
          }
        })
      })
    },
    async getBadges() {
      try {
        const params = { offset: 0, limit: 100 }
        let badges = await api.getBadges(params)
        this.badgeOptions = badges.data
        // console.log('badges', badges)
      } catch (e) {
        console.log(e)
      }
    },
    convertDate(date, name) {
      if (date == '') return
      let dateConvert = moment(date)
        .add(543, 'year')
        .format('DD/MM/YYYY')
      return dateConvert
    },
    test123(re) {
      // console.log('re : ', re)
    },
    addTag(newTag, k, stepindex) {
      const tag = newTag
      this.tagOptions.push(tag)
      if (!this.projectTypeData[k].steps[stepindex].tags) {
        Object.assign(this.projectTypeData[k].steps[stepindex], {
          tags: []
        })
      }
      if (!Array.isArray(this.projectTypeData[k].steps[stepindex].tags)) {
        this.projectTypeData[k].steps[stepindex].tags = this.projectTypeData[k].steps[
          stepindex
        ].tags.split(',')
      }
      this.projectTypeData[k].steps[stepindex].tags.push(tag)
      this.tagKey++
      this.update_tags.push(tag)
    },
    filteredName(item) {
      if (item.name) {
        return item.name
      } else if (item.coordinator_name) {
        return item.coordinator_name
      } else if (item.institute_name) {
        return item.institute_name
      }
    },
    beforeRemove(e) {
      // console.log(e)
    },
    updateInput(notify, e) {
      // console.log('updateInput')
      this.$forceUpdate()
    },
    onChangeSelect(val) {
      // console.log(val)
    },
    remove(item, i, j) {
      const index = this.projectTypeData[i].steps[j].notify.indexOf(item.memberid)
      if (index >= 0) this.projectTypeData[i].steps[j].notify.splice(index, 1)
    },
    saveDataTest() {},
    async saveData() {
      var isValid = await this.$validator.validate()
      if (isValid) {
        return new Promise(resolve => {
          this.saveloading = true
          var typedata = this.projectTypeData
          // console.log('typedata', typedata)
          var steps = []
          typedata = typedata.map(el => {
            return {
              ...el,
              steps: el.steps.map(val => {
                // if (val.notify) {
                //   let memberIdArr = val.notify.map(idx => {
                //     return idx.memberid
                //   })
                // console.log(memberIdArr)
                // }

                let output = { ...val, tags: val.tags }
                let dpType = val.dpType
                if (dpType === 'ไม่เปลี่ยนสถานะลูกค้า (default)') {
                  dpType = ''
                  output.dpType = dpType
                } else if (dpType === 'เปลี่ยนสถานะเป็น DP') {
                  dpType = 'DP'
                  output.dpType = dpType
                } else if (dpType === 'เปลี่ยนสถานะเป็น Non-DP') {
                  dpType = 'Non-DP'
                  output.dpType = dpType
                } else if (dpType === 'เปลี่ยนสถานะเป็น รออนุมัติ DP') {
                  dpType = 'รออนุมัติ DP'
                  output.dpType = dpType
                }

                return output
              })
            }
          })
          typedata.forEach(el => {
            steps = [...steps, ...el.steps]
          })
          var projectdata = steps.map(el => {
            if (el.notify) {
              var memberIdArr = el.notify.map(idx => {
                return Number(idx.memberid)
              })
            }
            let arrTags = []
            let tags = ''
            if (el.tags) {
              for (let i = 0; i < el.tags.length; i++) {
                arrTags.push(el.tags[i].tagcustomer)
              }
              tags = arrTags.join(',')
            }

            return {
              stepid: el.id,
              notify: memberIdArr,
              dpType: el.dpType,
              tags
            }
          })

          let preprojectsData = this.preprojects.map(item => {
            return Number(item.id)
          })

          let expMont = null
          if (this.monthdurationexpire == '1 เดือน') {
            expMont = 1
          } else if (this.monthdurationexpire == '3 เดือน') {
            expMont = 3
          } else if (this.monthdurationexpire == '6 เดือน') {
            expMont = 6
          } else if (this.monthdurationexpire == '1 ปี') {
            expMont = 12
          }

          var data = {
            ...this.input,
            projecteffdate: moment(this.input.projecteffdate).format('YYYY-MM-DD'),
            projectenddate: moment(this.input.projectenddate).format('YYYY-MM-DD'),
            showstartdate: moment(this.input.showstartdate).format('YYYY-MM-DD'),
            showenddate: moment(this.input.showenddate).format('YYYY-MM-DD'),
            preprojects: preprojectsData,
            projectdata: JSON.stringify(projectdata),
            typeid: parseInt(this.input.typeid),
            foruser: this.foruser.join(','),
            isautoapproved: this.isautoapproved ? true : false,
            autobadgeid: this.isautobadge ? this.autobadgeSelectId : null,
            isautodp: this.isautodp ? true : false,
            isconnecttechhunt: this.isconnecttechhunt ? true : false,
            applicantfee: this.isapplicantfee ? Number(this.applicantfee) : null,
            monthdurationexpire: this.ismonthdurationexpire ? expMont : null,
            isregistertechhunt: this.isregistertechhunt ? true : false,
          }
          // console.log(data)
          if (this.edittype == 'add') {
            var url = 'createdepaproject'
          } else {
            Object.assign(data, { projectid: this.input.id })
            var url = 'updatedepaproject'
          }
          // console.log('projectdata', projectdata)
          // console.log('data', data, url)

          api[url](data, (err, response) => {
            this.saveloading = false
            if (response.responsecode == 200) {
              this.$swal.fire({
                type: 'success',
                title: '<div class="headline primary--text bold7 fs-24">บันทึกสำเร็จ</div>',
                confirmButtonText: '<span style="color:#FFEF01">ปิด</span>'
              })
              if (this.edittype == 'add') {
                this.$emit('onCreate', response.data[0])
              } else {
                this.$emit('onUpdate', data)
              }
            }
            resolve()
          })
        })
      }
    },
    removeElement(notify, id) {
      var index = notify.findIndex(el => el == id)
      notify.splice(index, 1)
      this.$nextTick(() => {
        this.removed++
        this.$forceUpdate()
      })
    },
    customLabel(opt) {
      var type = this.optionsType.find(x => {
        return x.id == opt
      })
      if (type) {
        return type.typename
      } else {
        return ''
      }
    },
    customLabelUser(opt) {
      if (opt && opt.label) {
        var user = this.$store.state.usersdata.find(x => {
          var name = this.filteredName(x)
          return name.toLowerCase().includes(opt.label.toLowerCase())
        })
      } else {
        var user = this.$store.state.usersdata.find(x => {
          return x.memberid == opt
        })
      }

      if (user) {
        return user
      } else {
        return ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.multiselect__tag-icon:after {
  color: #80beff !important;
}
.multiselect__tag {
  background: #0e3154 !important;
}
.has-error .multiselect .multiselect__tags {
  border: 1px solid #ff3737 !important;
}

.uploaddepa {
  padding-right: 30px !important;
}
.v-input__slot {
  background-color: transparent !important;
}
.v-label {
  z-index: 20;
}
label.unit-text,
.unit-text input {
  position: relative;
  display: block;
  padding-right: 40px !important;
  width: 260px;
  box-sizing: border-box;
}

label.unit-text::after {
  content: attr(data-unit);
  position: absolute;
  top: 6px;
  right: 10px;
  font-size: 16px;
  display: block;
  color: #bdbdbd;
  font-weight: bold;
}
.typeCard {
  border-radius: 6px;
  .typeCardHeader {
    background: #beccdb;
    border-radius: 6px 6px 0px 0px;
    height: 66px;
    color: #0c2f53;
    display: flex;
    align-items: center;
    padding: 0 24px;
    .headerNumber {
      display: flex;
      width: 26px;
      height: 26px;
      justify-content: center;
      align-items: center;
      background: transparent;
      border-radius: 50%;
      border: 2px solid #0c2f53;
    }
    .headerNumber + .headerText {
      margin-left: 14px;
    }
  }
  .typeCardBody {
    border: 1px solid #beccdb;
    border-radius: 0px 0px 6px 6px;
    .typeCardStep {
      margin: 20px 14px 20px 14px;
      padding: 20px;
      border: 1px solid #beccdb;
      border-radius: 6px;
    }
  }
}
.customCancelBtn {
  font-weight: 700;
  font-size: 16px;
  width: 142px;
  margin: 0 7px;
}
.customConfirmBtn {
  color: yellow !important;
  font-weight: 700;
  font-size: 16px;
  width: 142px;
  margin: 0 7px;
}
</style>



// WEBPACK FOOTER //
// src/components/view/projectMaster/ProjectInfoEdit.vue